import { baseAPI } from "../../services/api";
import { transactionID } from "../../services/helpers";

export function addCardRequest({ msisdn, number, expiry, cvc, cpf, name }) {
  return baseAPI.post("/v2/addCard", {
    transactionId: transactionID("ADC"),
    msisdn,
    paymentType: "C",
    cardNumber: number,
    expiration: expiry,
    cvv: cvc,
    cpf,
    name,
  });
}
